import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BoardNewThreadForm from '../../components/board/BoardNewThreadForm';

function NewThread() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const categoryId = params.get('categoryId') ?? '';
  const subCategoryId = params.get('subCategoryId') ?? '';
  const template = params.get('template') ?? '';

  return (
    <div style={{ maxWidth: '672px', margin: '0 auto', padding: '24px 16px' }}>
      <nav style={{ fontSize: '13px', color: 'var(--ch-muted)', marginBottom: '16px' }}>
        <Link to="/board" style={{ color: 'var(--ch-link)' }}>トップ</Link>
        <span style={{ margin: '0 8px' }}>/</span>
        <span>スレッド作成</span>
      </nav>

      <h1 style={{ fontSize: '20px', fontWeight: 700, color: 'var(--ui-accent-text)', margin: '0 0 24px' }}>
        スレッドを作成
      </h1>

      <BoardNewThreadForm
        initialCategoryId={categoryId}
        initialSubCategoryId={subCategoryId}
        initialTemplate={template}
      />
    </div>
  );
}

export default NewThread;
